import type { CanActivateFn } from '@angular/router';

import { inject } from '@angular/core';
import { TuiAlertService } from '@taiga-ui/core';

import { TaxUserService } from '../service/user.service';

export function getIfTaxGuard(msg?: string): CanActivateFn {
  const IfTaxGuard: CanActivateFn = () => {
    const userSrv = inject(TaxUserService);
    const alertSrv = inject(TuiAlertService);
    const custDTO = userSrv.user()?.custDTO;
    if (!custDTO) {
      alertSrv.open('未查询到用户信息，请退出重试').subscribe();
      return false;
    }
    if (!custDTO.ifTax) {
      alertSrv.open(msg ?? '未完成税务登记,不可进入申报页面').subscribe();
      return false;
    }
    if (!custDTO.piTaxPwd) {
      alertSrv.open(msg ?? '未设置个税申报密码，不可进行个税申报，需优先完成个税申报密码提交待办').subscribe();
      return false;
    }
    return true;
  };

  return IfTaxGuard;
}
